import cx from 'classnames'
import React from 'react'

interface FormErrorMessageProps {
  children: React.ReactNode
  className?: string
}

export const FormErrorMessage = ({
  children,
  className
}: FormErrorMessageProps) => {
  return (
    <span
      className={cx(
        className || '[ f-d-bl f-m-b-020 f-c-fo-war ] FormError-wrapper'
      )}>
      {children}
    </span>
  )
}
